import { IAnalyticsTasks } from './IAnalyticsTasks';
import { UtilityService } from '../../../infrastructure/services/utils';
import { store } from '../../store';
import { IPageLoad } from './IPageLoad';
import { IResultClick } from './IResultClick';
import { ISearch } from './ISearch';
import { appConstants } from '../../configurations/constants';

/**
 * create model for analytics api payload
 * @param   {object} data api payload data
 * @param   {sting} contextKey guid for context key
 * @param   {sting} idToken authentication token
 */

export class AnalyticsModel {
  analyticsData: IAnalyticsTasks;

  constructor(data: IPageLoad | IResultClick | ISearch, contextKey: string) {
    const { userInfo } = store.getState().general;
    let currentTime : string = UtilityService.getCurrentUTCDateTime();
    const urlParam = new URLSearchParams(window.location.href).get('c')?.toLowerCase();
    this.analyticsData = {
          eventData: {
            SessionID: userInfo?.sessionId ?? null,
            Time: currentTime ? currentTime : null,
            Site: window.location.origin ? window.location.origin : null,
            Action: null,
            User: userInfo?.userEmail ?? null,
            PageURL: window.location.origin + window.location.pathname ? window.location.origin + window.location.pathname : null,
            UserServiceLine: userInfo?.EYServiceLine ?? null,
            UserSubserviceline: userInfo?.EYSubServiceLine ?? null,
            UserArea: userInfo?.EYArea ?? null,
            UserCountry: userInfo?.EYCountry ?? null,
            UserRank: userInfo?.EYRank ?? null,
            UserSpecialityName: userInfo?.EYSpecialityName ?? null,
            ...(urlParam === appConstants.intranet && { Channel: appConstants.intranetAnalytics })
          },

    };
  }


}